
import { defineComponent } from 'vue';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
// import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { useStore } from 'vuex';

export default defineComponent({
  setup() {
    const store = useStore();

    // const auth = getAuth();
    // onAuthStateChanged(auth, (user) => {
    //   if (user) {
    //     store.commit('setUser', user);
    //   } else {
    //     signInAnonymously(auth);
    //   }
    // });
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        store.commit('setUser', user);
      } else {
        firebase.auth().signInAnonymously();
      }
    });
  },
});
